<template>
  <section class="detail_box">
    <section class="detail_mess" v-if="showPage">
      <section class="status_box" v-if="applyData.numberType==3">
        <img
          v-if="applyData.applyStatus== 3 || applyData.applyStatus== 4"
          src="../../assets/images/icon_order_cancel.png"
        />
        <img
          v-else-if="applyData.applyStatus== 2"
          src="../../assets/images/icon_order_complete2.png"
        />
        <img v-else src="../../assets/images/icon_order_unpaidp.png" />
        <p :class="[applyData.applyStatus== 3?'':'']">{{applyData.applyStatus | applyText3}}</p>
      </section>
      <section class="status_box" v-if="applyData.numberType!=3">
        <img
          v-if="curData.applyStatus== 3 || curData.applyStatus== 4"
          src="../../assets/images/icon_order_cancel.png"
        />
        <img v-else-if="curData.applyStatus== 2" src="../../assets/images/icon_order_complete2.png" />
        <img v-else src="../../assets/images/icon_order_unpaidp.png" />
        <p :class="[curData.applyStatus== 3?'cancel':'']">{{curData.applyStatus | applyText}}</p>
      </section>
      <div class="yueBox" v-if="applyData.numberType!=3">
        <p class="tips" v-if="curData.applyStatus == 0">当前已无车位名额，请耐心排队等待候补车位</p>
        <section class="list first_list" v-if="curData.reason">
          <span class="list_left list_left_reason">拒绝理由</span>
          <p class="list_right list_right_reason">{{curData.reason}}</p>
        </section>
        <section :class="['list',curData.reason?'':'first_list']">
          <span class="list_left">月租费</span>
          <section class="month_price">
            <p class="type" v-if="curData.dayNightType == 1">
              <span>全保</span>(24小时)
            </p>
            <p class="type" v-else-if="curData.dayNightType == 3">
              <span>夜保</span>
              ({{curData.feeTypeStr || curData.feeTypeStr}}
              <i>+1</i>)
            </p>
            <p class="type" v-else>
              <span>日保</span>
              ({{curData.feeTypeStr || applyData.feeTypeStr}})
            </p>
            <p class="price">
              <span>{{curData.feeStandard}}</span>
              <i>元/月</i>
            </p>
          </section>
        </section>
      </div>
      <div class="yueBox" v-if="applyData.numberType==3">
        <section class="list first_list" v-if="applyData.reason">
          <span class="list_left list_left_reason">拒绝理由</span>
          <p class="list_right list_right_reason">{{applyData.reason}}</p>
        </section>
      </div>
      <div class="topline" v-if="fromType=='2'"></div>
      <section class="list" v-if="fromType=='2'">
        <span class="list_left">企业名称</span>
        <p class="list_right">{{applyData.companyName}}</p>
      </section>
      <section class="list">
        <span class="list_left">申请人</span>
        <p class="list_right">{{applyData.userName}}</p>
      </section>
      <section class="list">
        <span class="list_left">生效期限</span>
        <p v-if="applyData.numberType==3" class="list_right">
          {{applyData.applyStartDay | timeFormat}} 至 {{applyData.applyEndDay | timeFormat}}
          <span
            v-if="isTime"
          >即将到期</span>
        </p>
        <p v-else class="list_right">
          {{curData.applyStartDay | timeFormat}} 至 {{curData.applyEndDay | timeFormat}}
          <span
            v-if="isTime"
          >即将到期</span>
        </p>
      </section>
      <section class="list" v-if="fromType!='2'">
        <span class="list_left">月保类型</span>
        <p class="list_right">{{curData.parkTypeName}}</p>
      </section>
      <!-- <div class="topline" ></div> -->
      <!-- 车牌号 -->
      <section
        :class="['card_box',item.applyStatus=='1' && applyData.applyStatus == 2?'card_box_wait':'',item.applyStatus=='3' && applyData.applyStatus == 2?'card_box_fail':'']"
        v-for="item in cardList"
        :key="item.cardNumber"
      >
        <section class="list card_top border-top">
          <span class="list_left">车牌号</span>
          <section class="card_numberbox">
            <p
              :class="['card_number',item.plateNo.length === 9?'card_number_x':'']"
            >{{item.plateNo}}</p>
            <span
              class="card_status_wait"
              v-if="item.applyStatus=='1' && applyData.applyStatus == 2"
            >审批中</span>
            <span
              class="card_status_fail"
              v-else-if="item.applyStatus=='3' && applyData.applyStatus == 2"
            >审批失败</span>
          </section>
        </section>
        <section class="list" v-if="item.filesList && item.filesList.length > 0">
          <span class="list_left">照片</span>
          <section class="pic_box" @click="toViewImg(item.filesList)">
            <section class="pics">
              <img
                class="icon"
                v-if="index < 3"
                v-for="(img,index) in item.filesList"
                :key="img.path"
                :src="img.path"
              />
            </section>
            <p class="look_more" v-if="item.filesList.length > 3">
              全部{{item.filesList.length}}张
              <img src="../../assets/images/icon_indicator_next.png" />
            </p>
          </section>
        </section>
        <!-- <section class="list card_top list_reason" v-if="item.reason">
        <span class="list_left list_left_reason_card">拒绝理由</span>
        <p class="list_right list_right_reason_card">{{item.reason}}</p>
        </section>-->
        <img
          class="delect_icon"
          @click="cardDelect(item)"
          v-if="fromType!=2&&((curData.applyStatus == '2' && canCardDelect) || (item.applyStatus == '3' && curData.applyStatus != '3'))"
          src="../../assets/images/parking/delete.png"
        />
      </section>
      <!-- 审批通过图标 -->
      <img
        class="succ_icon"
        v-if="curData.applyStatus == 2"
        src="../../assets/images/icon_take_effect.png"
      />
      <img
        class="succ_icon"
        v-if="curData.applyStatus == 4"
        src="../../assets/images/icon_take_effectt.png"
      />
       <img
        class="succ_icon"
        v-if="curData.applyStatus == 7"
        src="../../assets/images/icon_was_due.png"
      />
    </section>
    <!-- 查看合同 -->
    <section
      class="see_contract"
      v-if="(curData.applyStatus == 2 || curData.applyStatus == 4) && curData.contractUrl"
      @click="viewContract"
    >
      <img class="icon" src="../../assets/images/icon_contract.png" />
      <p>查看合同</p>
      <img class="arraw" src="../../assets/images/icon_indicator_next.png" />
    </section>
    <!-- <section class="see_contract" v-if="applyData.applyStatus == 2 && curData.contractUrl" @click="viewContract">
    <img class="icon" src="../../assets/images/icon_contract.png" />
    <p>下载合同</p>
    <img class="arraw" src="../../assets/images/icon_indicator_next.png">
    </section>-->
    <!-- 添加车牌 -->
    <section
      class="add_card"
      v-if="curData.applyStatus == 2 && cardList.length < 3 &&parkingMess.serverType!=2 && parkingMess.id != 8 && parkingMess.id != 9"
    >
      <section class="add_card_main" @click="addCardNumber">
        <img :src="require(`../../assets/images/btn_add_${$store.state.common.theme}.png`)" />
        <span>添加车牌</span>
      </section>
    </section>
    <!-- 删除 -->
    <p
      class="delect_box"
      @click="delectContract"
      v-if="fromType!=2 &&(applyData.applyStatus == 3 || applyData.applyStatus == 4)"
    >删除</p>
    <section class="footer_h"></section>
    <common-footer v-if="curData.applyStatus == 2" text="去缴费" :canClick="true" @btnClick="toPay"></common-footer>
  </section>
</template>

<script>
import util from '../../utils/util';
import { approvalMixin } from '../../utils/approvalMixin';
import storage from '../../utils/storage';
import { loadParkHeaderById, spaceUpPcHttp, serversHttp } from '../../utils/api';
import { mapState } from 'vuex';
import CommonFooter from '../../components/footer';
 import wx from 'weixin-js-sdk';
//import wx from 'jweixin-1.6.0'
export default {
  name: 'parkingApplyDetail',
  props: {},
  mixins: [approvalMixin],
  components: {
    CommonFooter
  },
  filters: {
    applyText(val) {
      if (val == '0') {
        return '已申请，等待候补中...'
      } else if (val == '1') {
        return '已申请，审批中...'
      } else if (val == '2') {
        return '审批通过，可享月租优惠~'
      } else if (val == '3') {
        return '申请失败，审批未通过!'
      } else if (val == '4') {
        return '已过期!'
      } else if (val == '7') {
        return '已失效!'
      } else {
        return '已申请，审批中...'
      }
    },
    applyText3(val) {
      if (val == 1) {
        return '临停优惠权限审批中…'
      } else if (val == 2) {
        return '临停优惠权限已开通~'
      } else if (val == 3) {
        return '临停优惠权限审核失败！'
      } else if (val == 4) {
        return '临停优惠权限已过期失效…'
      } else {
        return '临停优惠权限审批中...'
      }

    },
    timeFormat(val) {
      if (val) {
        return val.split(" ")[0]
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    }),
    isTime() {
      if (this.applyData.applyEndDay) {
        let day = this.applyData.applyEndDay.replace(/./g, '-');
        let curData = new Date().getTime()
        if (new Date(day) - curData < 24 * 60 * 60 * 30) {
          return true;
        } else {
          return false;
        }
      } else {
        return false
      }
    }
  },
  watch: {
    $route(to, from) {
      this.url = from.path
    }
  },
  data() {
    return {
      fromType: '1',
      parkHeaderId:'', //停车场id
      parkingSpaceId: '', //车位id
      contractId: '', //合同id
      sendStatus: false,//判断是否有车牌未正常发起审批流
      applyData: {},
      curData: [],//当前项的数据
      cardList: [],
      timemap: '',
      url: '',
      showPage: false,
      parkingMess: '',
      hex_md5_return: '',
      canCardDelect: false,//车牌是否可以删除
      searchFileUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/queryAttachmentListByOneData',
      hasTwoContract: false//是否有2份合同都是生效状态
    }
  },
  created() {
    //this.fromType=1;
    var self = this;
    if (this.$route.query.fromType) {
      this.fromType = this.$route.query.fromType;
      if (this.fromType == 2) {
        setTimeout(() => {
          document.title = '申请临停优惠';
          self.$route.meta.title = '申请临停优惠';
        }, 200);
      } else {
        setTimeout(() => {
          document.title = '停车月卡';
          self.$route.meta.title = '停车月卡';
        }, 200);
      }
    } else {
      setTimeout(() => {
        document.title = '停车月卡';
        this.$route.meta.title = '停车月卡';
      }, 200);
    }
    this.parkHeaderId = this.$route.query.parkHeaderId;
    this.parkingSpaceId = this.$route.query.parkingSpaceId;
    this.contractId = this.$route.query.contractId;
  },
  activated() {
    if (
      this.url.indexOf("viewImgs") > -1 ||
      this.url.indexOf("yulanpdf") > -1 ||
      this.url.indexOf("parkingPay") > -1 ||
      this.url.indexOf("addCardNumber") > -1 && !storage.getS('isNeedFresh')
    ) {
      return;
    }
    // 公钥+私钥+时间戳+平台
    let gong = 'vanke2019spaceup009'
    let si = '009vanke2019spaceup001'
    let platfrom = 'SaasMobile'
    this.timemap = new Date().getTime()
    let str = gong + si + this.timemap + platfrom
    this.hex_md5_return = this.$md5(str)
    this.loadParkLot()
    this.loadParkHeaderByIdAction();
  },
  mounted() {
  },
  methods: {
    loadParkHeaderByIdAction() {
      let params = {
        //  parkLotId:this.curData.parkLotId,
        id: this.parkHeaderId,
        url: "/parking/rstParkHeader/loadParkHeaderById"
      }
      loadParkHeaderById(params).then(res => {
        // loadParkHeaderByIdAction(params).then(res=>{
        console.log(res)
        if (res.res && res.res.code === 10000) {
          this.parkingMess = res.body.data

        }
      })

    },

    toPay() {
      if (this.applyData.prkParkApplyLogBeans.length >= 2 && this.hasTwoContract) {
        this.$router.push(`/parkingPay?id=${this.applyData.id}&parkHeaderId=${this.applyData.parkHeaderId}&xqContractId=${this.applyData.prkParkApplyLogBeans[0].id}`)
      } else {
        this.$router.push(`/parkingPay?id=${this.applyData.id}&parkHeaderId=${this.applyData.parkHeaderId}`)
      }
    },
    // 删除合同
    delectContract() {
      util.showModal("", '确定要删除该数据吗?', true, "确定", () => {
        util.showLoading()
        let params = {
          parkLotId: this.curData.parkLotId,
          id: this.curData.id,
          url: "/parking/rstParkLot/delApplay"
            // id:this.curData.parkLotId,
            // url: "/parking/rstParkLot/delParkLot"
        }
        loadParkHeaderById(params).then(res => {
          console.log(res)
          if (res.res && res.res.code === 10000) {
            storage.setS("isNeedFresh", true)
            setTimeout(() => {
              util.hideLoading()
              this.$router.go(-1)
            }, 2000)
          } else {
            util.hideLoading()
            util.showToast(res.res.msg)
          }
        })
      })
    },
    viewContract() {
      // console.log(this.applyData.prkParkApplyLogBeans[0].contractUrl)
      // localStorage.setItem("src", this.applyData.prkParkApplyLogBeans[0].contractUrl);
      // // 跳转地址 yulanpdf
      // this.$router.push(`/iframePage`);
      var url = serversHttp + "servers.api/systemApi/exportFile?url=" + encodeURIComponent(this.curData.contractUrl)
      console.log(url)
      localStorage.setItem("src", url);
      // 跳转地址
      this.$router.push(`/yulanpdf?parkLotId=${this.curData.parkLotId}&id=${this.curData.id}`);
    },
    addCardNumber() {
      this.$router.push(`/addCardNumber?parkLotId=${this.applyData.prkParkLotPlateBeans[0].parkLotId}&name=${this.applyData.userName}`)
    },
    toViewImg(item) {
      storage.set('imgs', JSON.stringify(item))
      this.$router.push("/viewImgs")
    },
    // 获取用户申请信息
    loadParkLot() {
      util.showLoading()
      let params = {
        userId: this.common.userId,
        id :this.parkingSpaceId,
        parkHeaderId: this.parkHeaderId ,
        lotType:2,
        url: "/parking/rstParkLot/loadParkLot"
      }
      loadParkHeaderById(params).then(res => {
        console.log(res)
        util.hideLoading()
        this.showPage = true;
        if (res.res && res.res.code === 10000 && res.body && res.body.data) {
          this.applyData = res.body.data;
          // 获取当前项数据
          let logBeansData = this.applyData.prkParkApplyLogBeans || [];
           console.log(JSON.stringify(logBeansData),this.contractId )
          let status2Num = 0;//成功的合同数量
          logBeansData.forEach(item => {
            if (item.sendStatus == 1) {
              this.sendStatus = true;
            }
            if (item.applyStatus == '2') {
              status2Num += 1;
            }
            if (item.id == this.contractId) {
              this.curData = item
            }
          })
          // if(this.fromType == '3'){
          //   this.curData =this.applyData
          // }
          console.log(JSON.stringify(this.curData),'this.curData' )
          if (status2Num >= 2) {
            this.hasTwoContract = true;
          }
          // 如果有车牌未发起审批流,进入页面默认发起审批
          if (this.sendStatus && this.applyData.bizFlag) {
            this.approvalProcess(this.applyData, () => { }, () => { })
          }
          // 车牌列表
          let cardData = this.applyData.prkParkLotPlateBeans || [];
          let num = 0;
          let cardList = [];
          cardData.forEach((item, index) => {
            if (item.applyStatus == '2') {
              num += 1
            }
            let plateNo = item.plateNo.slice(0, 2) + '·' + item.plateNo.slice(2)
            // if(this.curData.plateNo.indexOf(item.plateNo) > -1){

            cardList.push({
              reason: item.reason,
              id: item.id,
              parkLotId: item.parkLotId,
              applyStatus: item.applyStatus,
              filesList: [],
              plateNo: plateNo
            })

            // 获取车牌对应上传的图片
            this.getImgs(item, index)
            // }
          })
          if (num >= 2) {
            this.canCardDelect = true
          } else {
            this.canCardDelect = false
          }
          this.cardList = cardList
        } else {
          util.showToast(res.res.msg)
        }
      })
    },
    getImgs(item, index) {
      fetch(this.searchFileUrl + "?moduleCode=TCP&target=" + item.id + "&platform=SaasMobile" + "&timestamp=" + this.timemap + "&sign=" + this.hex_md5_return + "&companyId=" + this.common.marketInfo.cityId, {
        method: 'get',
        headers: {
          "Access-channel": "saas_rst"
        },
      }).then(response => response.json()).then(res => {
        console.log(res)
        this.cardList[index].filesList = res.data
      })
    },
    cardDelect(item) {
      util.showModal('', '确定要删除该车牌吗?', true, '确定', () => {
        this.delplateNo(item.parkLotId, item.id)
      })
    },
    delplateNo(parkLotId, id) {
      util.showLoading()
      let params = {
        parkLotId: parkLotId,
        id: id,
        url: "/parking/rstParkLot/delPlateNo"
      }
      loadParkHeaderById(params).then(res => {
        console.log(res)
        util.hideLoading()
        if (res.res && res.res.code === 10000 && res.body) {
          util.showToast('删除成功')
          storage.setS("isNeedFresh", true)
          this.loadParkLot()
        } else {
          util.showToast(res.res.msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.detail_box {
  background: #eee;
}
.detail_mess {
  background: #fff;
  position: relative;
  margin-bottom: 14px;
  .status_box {
    .flex();
    height: 50px;
    align-items: center;
    padding: 40px 28px 10px;
    img {
      width: 36px;
      height: 36px;
      margin-right: 16px;
    }
    p {
      font-size: 36px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      &.cancel {
        color: #fc3f56;
      }
    }
  }
  .tips {
    font-size: 26px;
    color: rgba(253, 152, 56, 1);
    line-height: 36px;
    margin-bottom: 40px;
    margin-left: 28px;
  }
  .yueBox {
    flex-direction: column;
  }
  .topline {
    margin-top: 20px;
    margin-left: 28px;
    margin-bottom: 20px;
    width: 694px;
    height: 2px;
    background: rgba(234, 234, 234, 1);
  }
  .list {
    .flex();
    padding-bottom: 28px;
    margin: 0 28px;
    .list_left {
      width: 152px;
      font-size: 28px;
      color: rgba(153, 153, 153, 1);
      line-height: 40px;
    }
    .list_left_reason {
      color: #fc3f56;
    }
    .list_left_reason_card {
      color: #fc3f56;
      font-size: 26px;
    }
    .list_right {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      flex: 1;
      span {
        height: 44px;
        background: rgba(253, 152, 56, 1);
        border-radius: 22px;
        padding: 0 10px;
        line-height: 44px;
        color: #fff;
        font-size: 24px;
        display: inline-block;
        margin-left: 10px;
      }
    }
    .list_right_reason {
      color: #fc3f56;
    }
    .list_right_reason_card {
      font-size: 26px;
    }
    .month_price {
      .flex(column);
      .type {
        font-size: 24px;
        color: rgba(102, 102, 102, 1);
        line-height: 40px;
        span {
          font-size: 28px;
          line-height: 40px;
          font-weight: bold;
          display: inline-block;
          margin-right: 12px;
        }
        i {
          color: #16bc84;
        }
      }
      .price {
        .flex();
        align-items: center;
        span {
          font-size: 44px;
          font-weight: bold;
          color: rgba(252, 63, 86, 1);
          line-height: 60px;
          margin-right: 8px;
        }
        i {
          font-style: normal;
          font-size: 26px;
          color: rgba(51, 51, 51, 1);
          margin-top: 10px;
        }
      }
    }
    .card_numberbox {
      flex: 1;
      .flex();
      .card_number {
        height: 44px;
        background: rgba(0, 135, 255, 1);
        border-radius: 4px;
        font-size: 28px;
        color: rgba(255, 255, 255, 1);
        line-height: 44px;
        text-align: center;
        padding: 0 8px;
        margin-right: 28px;
      }
      .card_number_x {
        background: linear-gradient(
          180deg,
          rgba(235, 255, 249, 1) 0%,
          rgba(134, 223, 193, 1) 100%
        );
        color: #333;
      }
      .card_status_wait {
        font-size: 24px;
        color: rgba(255, 173, 93, 1);
        line-height: 44px;
      }
      .card_status_fail {
        font-size: 24px;
        color: rgba(252, 63, 86, 1);
        line-height: 44px;
      }
    }
    .pic_box {
      .flex();
      flex: 1;
      height: 120px;
      align-items: center;
      .pics {
        flex: 1;
        .flex();
        img {
          height: 120px;
          width: 30%;
          margin-right: 3%;
          max-width: 120px;
        }
      }
      .look_more {
        font-size: 24px;
        color: rgba(153, 153, 153, 1);
        .flex();
        align-items: center;
        img {
          display: inline-block;
          width: 32px;
          height: 32px;
        }
      }
    }
  }
  .first_list {
    margin-top: 40px;
  }
  .card_box {
    padding: 0 28px;
    position: relative;
    .list {
      margin: 0;
    }
    .delect_icon {
      display: block;
      width: 44px;
      height: 44px;
      position: absolute;
      right: 0;
      top: 0;
      padding: 28px;
    }
  }
  .card_box_wait {
    background: #fffaf6;
  }
  .card_box_fail {
    background: #fff6f6;
  }
  .card_top {
    padding-top: 28px;
  }
  .list_reason {
    padding-top: 0;
  }
  .succ_icon {
    position: absolute;
    top: 26px;
    right: 26px;
    width: 124px;
    height: 124px;
  }
}
.see_contract {
  height: 100px;
  padding: 0 28px;
  background: #fff;
  margin-bottom: 14px;
  .flex();
  align-items: center;
  .icon {
    width: 44px;
    height: 44px;
    margin-right: 14px;
  }
  p {
    flex: 1;
    font-size: 32px;
    color: rgba(51, 51, 51, 1);
  }
  .arraw {
    width: 32px;
    height: 32px;
  }
}
.delect_box {
  width: 100%;
  height: 100px;
  line-height: 100px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  text-align: center;
  font-size: 32px;
  color: rgba(252, 63, 86, 1);
}
// 添加车牌
.add_card {
  .flex();
  justify-content: flex-end;
  padding: 20px 20px 20px 0;
  .add_card_main {
    width: 200px;
    height: 68px;
    border-radius: 34px;
    background: #fff;
    .flex();
    justify-content: center;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
    span {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
}
.footer_h {
  height: 120px;
}
</style>
